<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">

            <v-card style="min-width: 850px !important" v-if="selected.length > 0" class="size pt-10">
                <v-row align="center" justify="center">
                    <v-col cols="9">
                        <v-card-title class="justify-center">
                            <v-row align="center" justify="center">
                                <h4 class="text-uppercase blue_accent--text py-2">
                                    {{ $t('advanced_fulfillment_to_be_supplied.fill_orders') }}
                                </h4>
                            </v-row>
                        </v-card-title>

                        <div class="mb-6" style="font-weight:bold; margin: auto; width: 90%;"><label
                                class="mx-1 accent--text">{{
                                    $t('advanced_fulfillment_to_be_supplied.supply') }} {{ this.current_order_number }} {{
                                    $t('advanced_fulfillment_to_be_supplied.of') }} {{ this.selected.length }} {{
                                    $t('advanced_fulfillment_to_be_supplied.current_order') }}: {{
                                    this.selected[this.current_order_number -
                                        1].unique_order_number }}</label></div>


                        <div class="marker1-1 mt-0" style="font-weight:bold">
                            <v-row>
                                <v-col cols="9" class="py-0 my-0">
                                    <label class="mx-1 white_highlight--text">{{
                                        $t('advanced_fulfillment_to_be_supplied.products') }}</label>
                                </v-col>
                                <v-col cols="3" class="py-0 my-0 pr-4" justify="end" align="end">
                                    <label class="mx-1 white_highlight--text">{{
                                        $t('advanced_fulfillment_to_be_supplied.supplied') }}</label>
                                </v-col>
                            </v-row>
                        </div>

                        <div class="mt-0 mb-8" style="width: 90%; margin: auto; height: 50px;"
                            v-for="(product, i) of current_order_products.products" :key="i">
                            <v-row class="mt-3 mb-0" justify="center" align="center">
                                <v-col cols="2" class="py-0 my-0">
                                    <img :src="product.img || default_image"
                                        style="width: 80px; height: 80px; background-color: black;" />
                                </v-col>
                                <v-col cols="7" class="py-0 my-0">
                                    <label class="mx-1">{{ product.description }}</label>
                                </v-col>
                                <v-col cols="3" class="py-0 my-0 pr-4" justify="end" align="end">
                                    <label class="mx-1">{{ product.scanned }} / {{ product.quantity }}</label>
                                </v-col>
                            </v-row>
                        </div>

                        <br>
                        <br>
                        <div class="marker1-1 mt-0 mb-4" style="font-weight:bold">
                            <v-row>
                                <v-col cols="12" class="py-0 my-0">
                                    <label class="mx-1 white_highlight--text">{{
                                        $t('advanced_fulfillment_to_be_supplied.package') }}</label>
                                </v-col>
                            </v-row>
                        </div>

                        <v-row class="px-0 py-0 mt-1 mx-0" justify="center" align="center">
                            <v-col cols="8" class="py-0 my-0 px-2">
                                <v-autocomplete class="mt-0 py-0" v-model="selected_box" :items="boxes" item-value="id"
                                    item-text="name" :label="$t('advanced_fulfillment_to_be_supplied.select_box')"
                                    :rules="rules_required"></v-autocomplete>
                            </v-col>
                            <v-col cols="3" class="py-0 my-0 px-2">
                                <v-text-field class="py-0" v-model="selected_quantity"
                                    :label="$t('fulfillments_prepaid_pendings.boxes_per_order')" @blur="barcode = ''"
                                    :rules="numeric_required"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 mt-1 mx-0" justify="center" align="center">
                            <v-col cols="11" justify="end" align="end">
                                <!-- <v-btn color="secondary" class="white--text mr-2" outlined @click="downloadBarcode"
                                    :disabled="!can_download">{{
                                        $t('advanced_fulfillment_to_be_supplied.download_label')
                                    }}</v-btn> -->
                                <v-btn color="secondary" class="white--text" outlined :disabled="!can_download"
                                    @click="downloadLabel">{{
                                        $t('advanced_fulfillment_to_be_supplied.download_invoice')
                                    }}</v-btn>
                            </v-col>
                        </v-row>

                        <v-row class="px-0 py-0 mt-4 mx-0" justify="center" align="center">
                            <v-col cols="11" justify="end" align="end">
                                <v-row class="px-0 mx-0">
                                    <v-chip color="error" outlined style="font-weight: bold;"
                                        v-if="no_file_label_found_message"><v-icon class="mx-2">label_off</v-icon> {{
                                            $t('advanced_fulfillment_to_be_supplied.cannot_download_label') }}</v-chip>

                                    <v-spacer></v-spacer>

                                    <v-btn color="secondary" class="white_highlight--text mx-3" @click="cancel()">
                                        {{ $t('advanced_fulfillment_to_be_supplied.cancel') }}
                                    </v-btn>
                                    <v-btn v-if="selected.length > 1 && current_order_number < selected.length"
                                        @click="current_order_number++; loadOrder(current_order_number - 1)"
                                        color="secondary" class="white_highlight--text" :disabled="!can_next">{{
                                            $t('advanced_fulfillment_to_be_supplied.next') }}</v-btn>
                                    <v-btn v-else-if="current_order_number == selected.length" @click="cancel();"
                                        color="secondary" class="white_highlight--text" :disabled="!can_close">{{
                                            $t('advanced_fulfillment_to_be_supplied.finish') }}</v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        
        <v-dialog v-model="alert_modal" persistent max-width="90%">
            <v-card>
                <v-card-title class="justify-center">
                    <v-row align="center" justify="center">
                        <h3 class="text-uppercase" style="color: var(--v-blue_accent-base);">
                            {{ $t('advanced_fulfillment_to_be_supplied.' + modal_type) }}
                        </h3>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row align="center" justify="center" class="py-3 my-3 text-center">
                        <v-col cols="12">
                            <h4>{{ $t('advanced_fulfillment_to_be_supplied.' + modal_type + '_message') }}</h4>
                        </v-col>
                    </v-row>

                    <div class="d-flex" style="justify-content: center;">
                        <v-btn color="warning" class="white_highlight--text" @click="closeModal">
                            {{ $t('advanced_fulfillment_to_be_supplied.accept') }}
                        </v-btn>
                    </div>
                </v-card-text>
                <div class="marker2"></div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="modalAlreadyOpen" persistent max-width="50%">
            <v-card>
                <v-row align="center" justify="center" class="text-center py-8 px-10">
                    <v-col cols="12">
                        <h3>{{ $t('fulfillments_cod_pendings.multiple_fulfillment_tabs') }}</h3>
                    </v-col>
                </v-row>
                <div class="marker"></div>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color"
            style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>

import printJS from 'print-js'
import { HttpShipmentRepository } from '../../infrastructure/shipment_repository';
import { affShipmentsGetProductsByOrderUseCase } from '../../application/use_cases/aff_shipments_get_products_by_order_use_case'

export default {
    computed: {
        rules_required() { return [v => !!v || this.$t('create_appointment.validations.required_field')] },
        numeric_required() {
            return [
                v => /^(|\d)+$/.test(v) || this.$t('edit_appointment.product_details.validations.numbers'),
                v => !!v || this.$t('edit_appointment.validations.required_field')
            ];
        },
    },
    data() {
        return {
            current_order_number: 1,
            selected: JSON.parse(localStorage.getItem("afsupply")),
            current_order_products: [],
            can_next: false,
            can_download: false,
            all_scanned: false,
            can_close: false,
            modalAlreadyOpen: false,
            no_file_label_found_message: false,
            boxes: [],
            selected_box: '',
            selected_quantity: '',
            default_image: localStorage.getItem('language') == "en" ? '/img/default-product_en.png' : '/img/default-product_es.jpg',
            alert_modal: false,
            orderToShow: '',
            modal_type: '',
            barcode: '',
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
        }
    },
    async mounted() {
        await this.checkIfCanOpen(this.shipping_service);        
        
        this.loadOrder(this.current_order_number - 1);

        let self = this;
        const keyPressHandler = (e) => {
            if (self.last == true && /^\S+$/.test(e.key)) {
                self.barcode = e.key;
                self.last = false;
            }
            else if (e.code == "Enter") {
                self.last = true;
                self.updateList();
            }
            else if (/^\S+$/.test(e.key)) self.barcode += e.key;
        };
        window.addEventListener('keypress', keyPressHandler, { capture: true });

        this.$once('hook:beforeDestroy',
            () => window.removeEventListener('keypress', keyPressHandler)
        );

        this.loadBoxes();
    },
    methods: {
        async loadOrder(index) {
            try {
                this.current_order_products = [];
                this.can_next = false;
                this.no_file_label_found_message = false;
                this.can_close = false;
                this.can_download = false;
                this.all_scanned = false;
                this.alert_modal = false;
                this.modal_type = '';
                this.barcode = '';
                this.selected_box = '';
                this.selected_quantity = '';
                const response = await affShipmentsGetProductsByOrderUseCase(this.selected[index].id, HttpShipmentRepository);

                response.products = response.products.map(product => ({ ...product, scanned: 0 }));
                this.current_order_products = response;
            }
            catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null ? e : e.response.data
                }
            }
        },
        async loadBoxes() {
            this.boxes = [];

            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");

            this.$http.get(this.$store.state.chronosApi + 'boxes', { headers: { Authorization: lsToken } })
                .then((response) => {
                    response.data.data.forEach(x => {
                        x = x.attributes;
                        this.boxes.push(x)
                    })
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.$store.state.loaderProps.visible = false;
                })
        },
        async downloadLabel() {
            const box = this.boxes.find(x => {
                if (x.id == this.selected_box) return x;
            })

            if (!this.validateBoxAndProducts(box)) return;

            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            const shipments = {
                "shipments": [{
                    "id": this.selected[this.current_order_number - 1].id,
                    "unique_order_number": this.selected[this.current_order_number - 1].unique_order_number,
                    "client_id": this.selected[this.current_order_number - 1].client.id,
                    "boxes": {
                        "quantity": parseInt(this.selected_quantity),
                        "box_id": box.id,
                        "weight": box.volumetricWeight
                    }
                }]
            }

            this.$http.post(this.$store.state.chronosApi + 'v1/advanced_fulfillment/generate_labels', shipments, { headers: { Authorization: lsToken } })
                .then((response) => {
                    printJS({ printable: response.data.images, type: 'image' });
                    this.$store.state.loaderProps.visible = false;
                }).catch((e) => {
                    console.log(e);
                    this.no_file_label_found_message = true;
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e.response == null ? e : e.response.data.fault.message
                    }
                }).finally(() => {
                    if (this.current_order_number < this.selected.length) this.can_next = true;
                    else this.can_close = true;
                    this.$store.state.loaderProps.visible = false;
                })
        },
        validateBoxAndProducts(box) {
            if (box == null) {
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('advanced_fulfillment_to_be_supplied.select_box_first')
                }
                return false;
            }

            if (this.selected_quantity == "" || (isNaN(this.selected_quantity) || isNaN(parseFloat(this.selected_quantity)))) {
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('advanced_fulfillment_to_be_supplied.wron_box_count')
                }
                return false;
            }

            var products_valid = true;

            this.current_order_products.products.forEach(x => {
                if (x.scanned < x.quantity) {
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('advanced_fulfillment_to_be_supplied.product_not_scanned')
                    }
                    products_valid = false;
                    return false;
                }
            })

            return products_valid;
        },
        async updateList() {
            let found = false;
            let discounted = false;
            let all_are_scanned = true;
            this.barcode = this.barcode.toString().replaceAll("Enter", "");

            this.current_order_products.products.forEach(x => {
                if (discounted == true) return;
                if (x.barcode.toString().toLowerCase() == this.barcode.toString().toLowerCase()) found = true;
                if (x.color == 'green') {
                    if (x.scanned < x.quantity && x.barcode.toString().toLowerCase() != this.barcode.toString().toLowerCase()) {
                        this.modal_type = "incomplete"
                        this.alert_modal = true;
                    }

                    x.color = 'accent'
                    this.previous_product = x.description;
                }

                if (x.barcode.toString().toLowerCase() == this.barcode.toString().toLowerCase() && x.scanned < x.quantity) {
                    x.color = 'green';
                    x.scanned++;
                    discounted = true;
                    return;
                }
            })

            this.current_order_products.products.forEach(x => {
                if (x.scanned < x.quantity) {
                    all_are_scanned = false;
                    return;
                }
            })

            this.all_scanned = all_are_scanned;

            if (discounted == false && found) {
                this.modal_type = "excedent"
                this.alert_modal = true;
                return;
            }

            if (!found && this.previous_product != "") {
                this.modal_type = "incorrect_product";
                this.alert_modal = true;
                return;
            }

            else if (!found) {
                this.modal_type = "not_expected_product";
                this.alert_modal = true;
                return;
            }

            this.can_download = await this.validateDownloadLabelAndBarcode();
        },
        closeModal() {
            this.alert_modal = false;
        },
        cancel() {
            localStorage.removeItem('afsupply');
            this.$router.go(-1);
        },
        async validateDownloadLabelAndBarcode() {
            return (this.selected_box != "" && this.selected_quantity != "" && this.all_scanned);
        },
        checkIfCanOpen(parcel){
            localStorage.open_pages = Date.now();
            window.addEventListener('storage', (e) => {
                if(e.key == "open_pages") localStorage.setItem("a_fulfillment_" + parcel, Date.now())
                if(e.key == "a_fulfillment_" + parcel) this.modalAlreadyOpen = true;              
            }, false);
        },
    },
    watch: {
        'selected_box': async function () {
            this.can_download = await this.validateDownloadLabelAndBarcode();
        },
        'selected_quantity': async function () {
            this.can_download = await this.validateDownloadLabelAndBarcode();
        }
    }
}
</script>

<style></style>